import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWizard } from '../../contexts/WizardContext';

// Import icons
import closeIcon from '../../assets/icons/close-x.svg';
import closeBg from '../../assets/icons/close-bg.svg';

interface SignupRedirectPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const SignupRedirectPopup: React.FC<SignupRedirectPopupProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { wizardData, resetWizard } = useWizard();

  const handleSignUp = () => {
    // Navigate to signup with wizard data
    navigate('/signup', {
      state: {
        wizardData: {
          name: wizardData.name,
          email: wizardData.email,
          phone: wizardData.phone,
          specialty: wizardData.specialties[0] || '',
        },
      },
    });
  };

  const handleBackToHome = () => {
    resetWizard();
    navigate('/');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-lg w-full relative">
        {/* Close button */}
        <button onClick={onClose} className="absolute top-4 sm:top-6 right-4 sm:right-6 size-8 min-h-[44px] min-w-[44px] flex items-center justify-center">
          <div className="relative size-8">
            <img alt="" className="absolute inset-0" loading="lazy" src={closeBg} />
            <img
              alt=""
              className="absolute bottom-[25%] left-[25%] right-[25%] top-[25%]"
              loading="lazy"
              src={closeIcon}
            />
          </div>
        </button>

        <div className="p-6 sm:p-8 text-center">
          <h2 className="font-['Ovo',_serif] text-[24px] sm:text-[32px] text-[#1f1f1f] mb-4">
            Your CLOUT Journey Begins!
          </h2>


          <p className="font-['Ovo',_serif] text-[14px] sm:text-[16px] text-[#767472] mb-6 sm:mb-8">
            Complete your registration to start building your professional profile and connect with
            potential clients.
          </p>

          <div className="flex flex-col gap-3 sm:gap-4">
            <button
              onClick={handleSignUp}
              className="w-full px-6 py-3 sm:py-4 min-h-[44px] bg-[#c6a664] text-white font-['Ovo',_serif] text-[16px] sm:text-[18px] uppercase hover:bg-[#b89654] transition-colors"
            >
              Sign Up Now
            </button>

            <button
              onClick={handleBackToHome}
              className="w-full px-6 py-3 sm:py-4 min-h-[44px] border border-[#1f1f1f] text-[#1f1f1f] font-['Ovo',_serif] text-[16px] sm:text-[18px] uppercase hover:bg-[#f5f5f5] transition-colors"
            >
              Back to Homepage
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupRedirectPopup;
